import {
  IconButton,
  InputAdornment,
  Stack,
  styled,
  Typography,
  Backdrop,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { MuiTextField } from "../textfield/MuiTextField";
import styles from "../../../pages/user-management/create-user/create-user/CreateUser.module.css";
import strings from "../../../strings/Strings";
import ImageAssets from "../../../assets";
import { CoutryCodeSelectionDialog } from "./PhoneNumber.style";
import { countryCodeJson } from "../../../core/json/CountryCodeJson";

const PhoneNumber = (props: any) => {
  const {
    countryCode,
    value,
    handleCountryCodeSelection,
    errorMessage,
    validateForm,
    handleInputChange,
    disabled = false,
    autoFocus = false,
    component
  } = props;

  const [isCountryCodeClicked, setIsCountryCodeClicked] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState(countryCodeJson);
  const [country, setCountry] = useState("");

  const handleCountrySearch = (e: any) => {
    const searchTerm = e.target.value;
    setCountry(searchTerm);
    const filteredOptions = countryCodeJson.filter((option: any) =>
      option?.name?.toLowerCase().includes(searchTerm?.toLowerCase())
    );
    setFilteredOptions(filteredOptions);
  };

  const handleCloseDialog = () => {
    setIsCountryCodeClicked(false);
    setFilteredOptions(countryCodeJson);
    setCountry("");
  };

  const Wrapper = styled("div") <any>`
    .error-message-container {
      position: absolute;
      font-size: 1.6rem;
    }

    @media screen and (max-width: 376px) {
      .error-message-container {
        position: relative !important;
      }
    }
  `;

  const Item = styled("div") <any>`
    margin-top: 0px !important;
    padding: ${({ theme }) => theme.spacing(0.5)};
    text-align: "center";
  `;

  return (
    <div>
      <MuiTextField
        fullWidth
        type="tel"
        value={value}
        onChange={(e: any) => handleInputChange(e)}
        onBlur={(e: any) => validateForm(e)}
        name="phoneNumber"
        errormessage={errorMessage}
        label={strings.enterPhoneNumber}
        maxLength={10}
        disabled={disabled}
        autoFocus={autoFocus}
        component={component}
        InputProps={{
          startAdornment: (
            <>
              <InputAdornment position="start" style={{ cursor: "pointer" }}>
                <Typography
                  component={"span"}
                  onClick={() => setIsCountryCodeClicked(true)}
                  variant={"h2"}
                  display="flex"
                  alignItems={"center"}
                  sx={{
                    color:
                      !props.value && errorMessage !== "" ? "#ff7e98" : "white",
                  }}
                >
                  {countryCode ? countryCode : "+91"}
                  <IconButton edge="end">
                    <img
                      src={
                        // isDropDownMenuOpen
                        //   ? ImageAssets.ic_dropup
                        //   :
                        ImageAssets.ic_dropdownb
                      }
                      className="dropdown"
                      alt=""
                      style={{ width: "20px" }}
                    />
                  </IconButton>
                  <IconButton edge="end">
                    <img
                      src={ImageAssets.ic_divider}
                      alt=""
                      style={{ width: "1.5px" }}
                    />
                  </IconButton>
                </Typography>
              </InputAdornment>
            </>
          ),
        }}
      />

      {isCountryCodeClicked ? (
        <CoutryCodeSelectionDialog
          open={isCountryCodeClicked}
          onClose={() => {
            handleCloseDialog();
          }}
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          // open={open}
          // onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        // width={"40rem"}
        >
          <div className="container">
            <div className="dialog-container">
              <img
                src={ImageAssets.ic_white_close}
                alt="close-icon"
                className="close-icon"
                onClick={() => handleCloseDialog()}
              />
              <TextField
                fullWidth
                type="tel"
                value={country}
                onChange={(e: any) => handleCountrySearch(e)}
                onBlur={(e: any) => validateForm(e)}
                name="phoneNumber"
                placeholder={strings.countrycode}
                InputProps={{
                  startAdornment: (
                    <>
                      <InputAdornment
                        position="start"
                      // style={{ cursor: "pointer" }}
                      >
                        <img alt="search" src={ImageAssets.ic_search} />
                      </InputAdornment>
                    </>
                  ),
                }}
              />
              <Stack className="country-lists">
                {filteredOptions?.map((option: any, index: any) => {
                  return (
                    <>
                      <div className="line-break"></div>
                      <Stack
                        className="country-code"
                        onClick={() => {
                          handleCountryCodeSelection(option?.dial_code);
                          handleCloseDialog();
                        }}
                      >
                        <img
                          className={styles["flags"]}
                          srcSet={`https://flagcdn.com/w40/${option?.code?.toLowerCase()}.png 2x`}
                          src={`https://flagcdn.com/w20/${option?.code?.toLowerCase()}.png`}
                          alt=""
                        />

                        <span>{option?.dial_code}</span>
                        <p>{option?.name}</p>
                      </Stack>
                    </>
                  );
                })}
              </Stack>
            </div>
          </div>
        </CoutryCodeSelectionDialog>
      ) : null}
    </div>
  );
};

export default PhoneNumber;
